export default __webpack_public_path__ + "static/media/drugs_dark.d4fdb326.jpeg";